import { render } from "./BasicLayout.vue?vue&type=template&id=18972fbd&ts=true"
import script from "./BasicLayout.vue?vue&type=script&lang=ts"
export * from "./BasicLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__